class ClearPass extends THREE.Pass {
    constructor(clearColor, clearAlpha) {
        super();

        this.clearColor = clearColor;
        this.clearAlpha = (clearAlpha !== undefined) ? clearAlpha : 0;

        this.clear = true;
        this.clearDepth = false;
        this.needsSwap = false;
    }

    render(renderer, writeBuffer, readBuffer, delta, maskActive) {
        renderer.setRenderTarget(this.renderToScreen ? null : readBuffer);
        renderer.clear(true, true, true);
    }
}

export default ClearPass;
export { ClearPass };